import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'

import logo from 'assets/images/unifi-logo.svg'
import { Container } from 'elements'
import { LinkedNavigationMenu, UserActions, MobileNavbar } from '../'
import { userSelector } from 'redux/selectors'

import './index.scss'

const COMPONENT_CSS_CLASS = 'nav-bar'
const bemE = (suffix) => `${COMPONENT_CSS_CLASS}__${suffix}`

class NavBar extends Component {
  render = () => {
    const { user } = this.props
    const operator = user && user.currentUser && user.currentUser.operator

    // Check if the logged in user is Groucho's tablet.
    const tabletMode = (
      (operator && operator.clientId === 'groucho')
      && (operator && operator.username === 'ClubTablet')
    )

    // Groucho's tablet user won't have access to navigation elements, only the
    // user menu. Users can still navigate by changing the URL instead but then
    // this is just a hack so who gives a
    return (
      <div className={COMPONENT_CSS_CLASS}>
        <Container className={bemE('container')}>
          <img className={bemE('logo')} src={logo} alt="logo" />
          {tabletMode || <LinkedNavigationMenu />}
          <UserActions />
          {tabletMode || <MobileNavbar />}
        </Container>
      </div>
    )
  }
}

export const selectors = createStructuredSelector({
  user: userSelector
})

export const actions = {}

export default compose(
  connect(selectors, actions),
)(NavBar)



// WEBPACK FOOTER //
// ./src/smart-components/nav-bar/index.js